export default __webpack_public_path__ + "static/media/TheNewYear_18.7ff3ed9f.png";